import type { AnimationItem } from 'lottie-web'
import { Button, Modal } from 'antd-mobile'
import lottie from 'lottie-web'
import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import diamond from '@/assets/diamond.png'
import fireworksJson from '@/assets/lottie/fireworks.json'
import { openBtokVipPurchaseActivity } from '@/utils/native/func'

interface DialogSuccessProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const DialogSuccess: React.FC<DialogSuccessProps> = ({ open, onOpenChange }) => {
  const animationRef = useRef<AnimationItem | null>(null)
  const { t } = useTranslation()
  useEffect(() => {
    if (open) {
      animationRef.current = lottie.loadAnimation({
        container: document.getElementById('animation-container')!,
        // path: '/lottie/fireworks.json', // 动画文件路径
        animationData: fireworksJson,
        renderer: 'svg',
        loop: false, // 只播放一次
        autoplay: true, // 自动开始播放
      })
      const handleComplete = () => {
        animationRef.current?.destroy()
        animationRef.current = null
      }
      animationRef.current.addEventListener('complete', handleComplete)
    }

    return () => {
      animationRef.current?.destroy()
      animationRef.current = null
    }
  }, [open])

  return (
    <Modal
      visible={open}
      closeOnMaskClick={true}
      onClose={() => {
        onOpenChange(false)
      }}
      maskClassName="__CustomMask__bg"
      bodyClassName="__CustomModal__ bg-[url('@/assets/dialogSucce_bg.png')] bg-cover bg-center overflow-visible"
      actions={[]}
      content={
        <div>
          <div className="flex items-center justify-center -mt-24">
            <img className=" w-34 h-34" src={diamond} alt="" />
          </div>
          <div className="text-center text-xl font-bold mt-4">{t('common.thankYou')}</div>
          <div className="text-center text-lg font-medium mt-1">{t('common.purchaseSuccess')}</div>
          <Button
            type="button"
            className="w-full mt-5 h-12 rounded-full bg-gradient-to-r from-[rgba(254,153,33,1)] to-[rgba(255,66,59,1)] text-white font-medium text-base border-0"
            onClick={openBtokVipPurchaseActivity}>
            {t('common.enterVipPage')}
          </Button>
        </div>
      }></Modal>
  )
}

export default DialogSuccess
